import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiConfigService {
  private apiUrlValue: string = environment.apiUrl;
  private recaptchaEnabledValue: boolean =
    environment.reCaptchaOptions?.isEnabled ?? false;
  private recaptchaSiteKeyValue: string =
    environment.reCaptchaOptions?.siteKey ?? '';

  constructor(private http: HttpClient) {}

  async loadConfig(): Promise<void> {
    try {
      const config = await firstValueFrom(
        this.http.get<any>('/assets/config.json')
      );

      if (config?.apiUrl) {
        this.apiUrlValue = config.apiUrl;
      }

      if (config?.recaptchaEnabled !== undefined) {
        this.recaptchaEnabledValue = config.recaptchaEnabled;
      }

      if (config?.recaptchaSiteKey) {
        this.recaptchaSiteKeyValue = config.recaptchaSiteKey;
      }
    } catch {}
  }

  get apiUrl(): string {
    return this.apiUrlValue;
  }

  get recaptchaEnabled(): boolean {
    return this.recaptchaEnabledValue;
  }

  get recaptchaSiteKey(): string {
    return this.recaptchaSiteKeyValue;
  }
}
